import { i18n } from '@lingui/core'
import { messages as zhMessages } from './locales/zh/messages'
import { messages as enMessages } from './locales/en/messages'

const availableLanguages = {
  en: enMessages,
  zh: zhMessages,
}
// 加载语言
i18n.load(availableLanguages)

// 设置默认语言
i18n.activate('zh')

export { i18n, availableLanguages }
